import {
	ChangeDetectionStrategy,
	Component,
	DestroyRef,
	Input,
	OnInit,
	ViewContainerRef,
	inject,
} from '@angular/core';
import { IActionConfig } from '../../interfaces';
import { ActionHandlerFactory } from '../../action-handlers/action-handler-factory';

@Component({
	selector: 'action-center-overlay',
	templateUrl: './action-center-overlay.component.html',
	styleUrls: ['./action-center-overlay.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [],
})
export class ActionCenterOverlayComponent implements OnInit {
	private readonly actionHandlerFactory = inject(ActionHandlerFactory);
	private readonly viewContainerRef = inject(ViewContainerRef);
	private readonly destroyRef = inject(DestroyRef);

	@Input() config: IActionConfig;
	//Todo:
	//This component is a work around for displaying different components at a specific point in the template.
	ngOnInit(): void {
		this.actionHandlerFactory.addDeps(this.viewContainerRef, this.destroyRef);
		const handler = this.actionHandlerFactory.createHandler(this.config.actionGroup);
		handler.handleAction(this.config);
	}
}
